import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, MapPin, CalendarDays, Images, Droplets } from 'lucide-react';
import { cn } from '../../lib/utils';

const items = [
  { to: '/', label: 'Início', icon: Home, testid: 'nav-home', end: true },
  { to: '/celulas', label: 'Células', icon: MapPin, testid: 'nav-cells' },
  { to: '/evento', label: 'Eventos', icon: CalendarDays, testid: 'nav-agenda' },

  { to: '/galeria', label: 'Galeria', icon: Images, testid: 'nav-gallery' },
];

export default function BottomNav() {
  return (
    <>
      {/* Mobile: persistent bottom navigation bar */}
      <nav
        className="fixed bottom-0 left-1/2 z-40 w-full max-w-[480px] -translate-x-1/2 border-t border-slate-200/60 bg-white/80 backdrop-blur-xl md:hidden"
        style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
        data-testid="bottom-nav"
      >
        <div className="flex items-stretch justify-around px-2 py-1.5">
          {items.map(({ to, label, icon: Icon, testid, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={testid}
              className="flex-1"
            >
              {({ isActive }) => (
                <div
                  className={cn(
                    'mx-auto flex min-h-[52px] w-full flex-col items-center justify-center gap-1 rounded-2xl py-1.5',
                    'transition-colors duration-200 ease-out',
                    isActive ? 'text-primary' : 'text-ink-faint hover:text-ink-soft'
                  )}
                >
                  <span
                    className={cn(
                      'flex h-8 w-14 items-center justify-center rounded-full transition-colors duration-200',
                      isActive && 'bg-primary-light'
                    )}
                  >
                    <Icon size={20} strokeWidth={isActive ? 2.4 : 2} />
                  </span>
                  <span className="text-[11px] font-semibold font-heading">{label}</span>
                </div>
              )}
            </NavLink>
          ))}
        </div>
      </nav>

      {/* Desktop: top navigation bar */}
      {/* <nav
        className="sticky top-0 z-40 hidden border-b border-slate-200/60 bg-white/80 backdrop-blur-xl md:block"
        data-testid="top-nav"
      >
        <div className="app-container flex h-16 items-center justify-between">
          <NavLink to="/" end className="flex items-center gap-2" data-testid="top-nav-logo">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary text-white shadow-soft">
              <Droplets size={20} />
            </span>
            <div className="text-left leading-tight">
              <p className="font-heading text-sm font-extrabold text-ink">Águas Vivas</p>
              <p className="text-[11px] font-medium text-ink-faint">Caratinga · MG</p>
            </div>
          </NavLink>

          <div className="flex items-center gap-1">
            {items.map(({ to, label, icon: Icon, testid, end }) => (
              <NavLink
                key={to}
                to={to}
                end={end}
                data-testid={testid}
                className={({ isActive }) =>
                  cn(
                    'flex items-center gap-2 rounded-full px-4 py-2.5 font-heading text-sm font-semibold transition-colors duration-200',
                    isActive
                      ? 'bg-primary-light text-primary'
                      : 'text-ink-soft hover:bg-slate-100 hover:text-primary'
                  )
                }
              >
                {({ isActive }) => (
                  <>
                    <Icon size={18} strokeWidth={isActive ? 2.4 : 2} />
                    {label}
                  </>
                )}
              </NavLink>
            ))}
          </div>
        </div>
      </nav> */}
    </>
  );
}
